import request from "@/utils/request";
// 获取嘉宾日程
export function getGuestAgenda(data) {
  return request({
    url: `/homeapi/guestagenda/getGuestAgenda?event_id=${data.event_id}&guest_id=${data.guest_id}`,
    method: "get",
  });
}

// 获取嘉宾信息
export function getGuestInfo(id) {
  return request({
    url: `/homeapi/Guestagenda/getGuestInfo?id=${id}`,
    method: "get",
  });
}

// 获取日程列表
export function getAgendaList(params) {
  return request({
    url: `/adminapi/Agenda/getAgendaListForview`,
    method: "get",
    params
  });
}
// 提交日程
export function commitAgenda(data) {
  return request({
    url: `/homeapi/guestagenda/confirmAgenda`,
    method: "post",
    data,
  });
}


// 获取日程详情
export function getAgendaDetail(id) {
  return request({
    url: `/homeapi/Agenda/getAgenda?id=${id}`,
    method: "get",
  });
}

// 获取子日程
export function getChilderAgenda(parent_id) {
  return request({
    url: `/homeapi/Agenda/getAgendaByParentId2?parent_id=${parent_id}`,
    method: "get",
  });
}

// 按字母获取嘉宾列表
export function getGuestList(id) {
  return request({
    url: `/homeapi/Guestagenda/getGuestsSearch?event_id=${id}`,
    method: "get",
  });
}

// 列表模式日程数据
export function getListmodeAgendaList(data) {
  return request({
    url: `/adminapi/Agenda/getAgendaListBydate?event_id=${data.event_id}&sub_schedule=${data.sub_schedule}&agenda_date=${data.agenda_date}&id=${data.id}&agenda_group=${data.agenda_group}&agenda_place=${data.agenda_place}`,
    method: "get",
  });
}

// 日程配置
export function getAgendaConfig(id) {
  return request({
    url: `/adminapi/Agenda/getAgendaConfig?id=${id}`,
    method: "get",
  });
}

// 日程其他配置
export function getAgendaConfigs(id) {
  return request({
    url: `/homeapi/Agenda/getAgendaConfigs?id=${id}`,
    method: "get",
  });
}
/**
 * 获取活动通知
 * params 
 */
export function getSystemEnDis (params) {
  return request({
    url: '/homeapi/Microsite/getSystemEnDis',
    method: 'get',
    params
  })
}

export function getEventInfo (params) {
  return request({
      url: '/homeapi/manage/getEventInfo',
      method: 'get',
      params
  })
}

